import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import type { QueryClient } from '@tanstack/react-query';
import { ErrorPage } from '@/features/errors/ErrorPage';
import { NotFoundPage } from '@/features/errors/NotFoundPage';

interface RouterContext {
  queryClient: QueryClient;
}

const RootComponent = () => {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  );
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  errorComponent: ErrorPage,
  notFoundComponent: NotFoundPage,
});
